export enum ImaTableGroups {
  CATEGORY = 'category',
  OVERALL_BUDGET = 'overallBudget',
  VENDOR_CONTRACT = 'vendorContract',
  VENDOR_ESTIMATE = 'vendorEstimate',
}
